import styled from 'styled-components';
import DatePicker from 'components/DatePicker';
import { H6, P } from 'components/Typography';
import { th } from 'style/theme';
import { sizes } from 'style';
import Alert from 'components/Alert';

export const ClaimHeading = styled(H6)`
  @media ${sizes.desktop} {
    margin-bottom: 12px;
    font-size: 20px;
  }
`;

export const FieldLabel = styled.b`
  display: block;
  margin-bottom: 8px;
`;

export const Description = styled(P)`
  font-size: 14px;
  line-height: 24px;
`;

export const EventDate = styled(DatePicker)`
  @media ${sizes.tabletPortrait} {
    max-width: calc(50% - 20px);
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;

  @media ${sizes.tabletPortrait} {
    flex-direction: row;
    align-items: flex-end;
    gap: 40px;

    > * {
      flex: 1;
    }
  }
`;

export const InputRow = styled.div`
  display: flex;
  margin-top: 8px;

  > :first-child {
    min-width: 160px;
    margin-right: 12px;
  }

  @media ${sizes.tabletPortrait} {
    max-width: calc(60% - 20px);
  }
`;

export const StyledAlert = styled(Alert)`
  margin-top: 16px;
`;
